import React from 'react';
import Answer from "../answer/Answer";
import './Question.scss';

const Question = props => {

  const answers = props.question.reponses.map((a, key) => {
    console.log(props.choices)
    const selected = props.selected.includes(a.lettre) // Answer is being selected
      || (props.choices && props.choices.values.includes(a.lettre));
    const incorrect = selected && !a.correcte;
    return <Answer key={key}
                   answer={a}
                   letter={a.lettre}
                   selected={selected}
                   selectAnswer={props.selectAnswer}
                   deselectAnswer={props.deselectAnswer}
                   showSolution={props.showSolution || props.showChoices}
                   incorrect={incorrect}
    />;
  });

  return (
    <section className="Question">
      <h2>{props.question.contenu}</h2>
      {answers}
    </section>
  );
};

export default Question;
